// auto-generated by {apiBaseUrl}/tools/typescriptmodels
export class RevisionSearchRequest {
	public ItemId: number = 0;
}